module.exports = __webpack_public_path__ + "img/nyyjs-2.bcce0f80.jpg";